<template lang="pug">
  #pageUserProfile

    #pageHeader
      h2.blockTitle Minha Conta

    #blockUserProfile

      .saveIcon
        v-progress-circular(v-if="loading" color="primary" indeterminate)

        p(v-else).success--text.ma-0.halfVisible
          v-icon(v-text="'mdi-account-check'" color="success").mr-2
          | Dados Salvos

      v-card-text

        v-row

          v-col(cols="12" lg="5" :class="['d-flex', 'align-center', 'justify-center', 'flex-column']")

            label#avatar-label(for="avatar")
              v-avatar(color="#ccc" :size="200")
                img#avatar-preview(:src="image.preview")
              v-btn#avatar-button(@click="setImage" color="primary" small fab dark)
                v-icon mdi-pencil

          v-col(cols="12" lg="7")

            form(@submit.prevent).px-4

              v-file-input#avatar(v-show="false" type="file" accept="image/png,image/jpg,image/jpeg" @change="handleImageChange" :disabled="loading")

              .field
                .fieldLabel
                  label(for="userName" data-type="required") Nome:
                .fieldBlock
                  v-icon(size="18" class="fieldIcon") mdi-account
                  input(type="text" v-model="nome" id="userName" placeholder="Seu Nome Completo Aqui" class="fieldInput" maxlength="64" :disabled="loading" @blur="saveProfile('name')")

              .field
                .fieldLabel
                  label(for="userEmail" data-type="required") E-mail:
                .fieldBlock
                  v-icon(size="18" class="fieldIcon") mdi-email
                  input(type="text" v-model="email" id="userEmail" placeholder="email@exemplo.com.br" class="fieldInput" disabled readonly)

              .field
                .fieldLabel
                  label(for="userPhone" data-type="required") Telefone:
                .fieldBlock
                  v-icon(size="18" class="fieldIcon") mdi-phone
                  input(type="tel" id="userPhone" placeholder="(00) 00000-0000" class="fieldInput" maxlength="15" :disabled="loading" @input="onPhoneChange" @paste="onPhoneChange" :value="phone" @blur="saveProfile('phone')")

              .field
                .fieldLabel
                  label(for="userCPF") CPF:
                .fieldBlock
                  v-icon(size="18" class="fieldIcon") mdi-account-box-outline
                  input(type="tel" ref="userCPF" id="userCPF" placeholder="000.000.000-00" class="fieldInput" maxlength="14" :disabled="loading" @input="onCpfChange" @paste="onCpfChange" :value="cpf" @blur="saveProfile('cpf')")

              .field
                .fieldLabel
                  label(for="userCRM") CRM:
                .fieldBlock
                  v-icon(size="18" class="fieldIcon") mdi-medical-bag
                  input(type="text" v-model="crm" id="userCRM" placeholder="0000/UF" class="fieldInput" maxlength="13" :disabled="loading" @blur="saveProfile('crm')")

              .field
                .fieldLabel
                  label(for="userPaymentData") Dados bancários:
                .fieldBlock
                  v-icon(size="18" class="fieldIcon") mdi-account-cash
                  textarea(type="text" v-model="conta" id="userPaymentData" placeholder="Informe seu Banco, Agência, Conta, CPF, CNPJ, Operação, PIX e outros dados necessários para receber pagamentos" class="fieldTextarea" maxlength="160" :disabled="loading" @blur="saveProfile('payment')")

</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import 'firebase/storage'

  import { mapState } from 'vuex'

  import { apiGetUserId, fbFullUpdate } from '@/services/firebase'

  import { isValidCPF } from '@/mixins/utils'

  function setImage () {
    document.getElementById('avatar').click()
  }

  const ImageSelectPlaceholder = 'https://firebasestorage.googleapis.com/v0/b/sosapp-bd22b.appspot.com/o/images%2Fsemimagem.png?alt=media&token=32aad9b2-88e2-40c5-9976-6766ea5af59d'

  export default {
    name: 'Profile',

    data: () => ({
      loading: true,
      image: {
        preview: ImageSelectPlaceholder,
        file: null,
      },
      nome: '',
      email: '',
      ddd: '',
      tel: '',
      phone: '',
      cpf: '',
      crm: '',
      conta: '',
    }),

    computed: {
      ...mapState(['userSession']),

      hasChanged () {
        const userImg = String(this.userSession.userProfile.img).trim()
        const userNome = String(this.userSession.userProfile.nome).trim()
        const userEmail = String(this.userSession.userProfile.email).trim()
        const userPhone = String(this.userSession.userProfile.phone).trim()
        const userDdd = String(this.userSession.userProfile.ddd).trim()
        const userTel = String(this.userSession.userProfile.tel).trim()
        let userCpf = String(this.userSession.userProfile.cpf).replace(/[^0-9]/g, '')
        userCpf = userCpf.length > 11 ? userCpf.slice(0, 11) : userCpf
        const userCrm = String(this.userSession.userProfile.crm).trim()
        const userConta = String(this.userSession.userProfile.conta).trim()

        const img = String(this.image.preview).trim()
        const nome = String(this.nome).trim()
        const email = String(this.email).trim()
        const phone = String(this.phone).trim()
        const ddd = String(this.ddd).trim()
        const tel = String(this.tel).trim()
        let cpf = String(this.cpf).replace(/[^0-9]/g, '')
        cpf = cpf.length > 11 ? cpf.slice(0, 11) : cpf
        const crm = String(this.crm).trim()
        const conta = String(this.conta).trim()

        // [24/01/25] if (img !== userImg) console.log(`img[hasChanged]: "${userImg}" > "${img}"`)
        // [24/01/25] if (nome !== userNome) console.log(`nome[hasChanged]: "${userNome}" > "${nome}"`)
        // [24/01/25] if (email !== userEmail) console.log(`email[hasChanged]: "${userEmail}" > "${email}"`)
        // [24/01/25] if (phone !== userPhone) console.log(`phone[hasChanged]: "${userPhone}" > "${phone}"`)
        // [24/01/25] if (ddd !== userDdd) console.log(`ddd[hasChanged]: "${userDdd}" > "${ddd}"`)
        // [24/01/25] if (tel !== userTel) console.log(`tel[hasChanged]: "${userTel}" > "${tel}"`)
        // [24/01/25] if (cpf !== userCpf) console.log(`cpf[hasChanged]: "${userCpf}" > "${cpf}"`)
        // [24/01/25] if (crm !== userCrm) console.log(`crm[hasChanged]: "${userCrm}" > "${crm}"`)

        return this.userSession && this.userSession.userProfile && (
          userImg !== img ||
          userNome !== nome ||
          userEmail !== email ||
          userPhone !== phone ||
          userDdd !== ddd ||
          userTel !== tel ||
          userCpf !== cpf ||
          userCrm !== crm ||
          userConta !== conta
        )
      },
    },

    watch: {
      //
      // '$store.state.userSession': function () {
      //

      '$store.state.userSession': {
        deep: true,
        immediate: true,
        handler (defaultNew, defaultOld) {
          this.getUserFromStore('watch')
        },
      },
    },

    mounted () {
      this.getUserFromStore('mounted')
    },

    beforeDestroy () {
      // this.userSession = {}
      this.image = {
        preview: ImageSelectPlaceholder,
        file: null,
      }
      this.nome = ''
      this.email = ''
      this.ddd = ''
      this.tel = ''
      this.cpf = ''
      this.crm = ''
      this.conta = ''
    },

    methods: {
      applyPhoneMask (phone) {
        let vPhone = String(phone).trim()
        vPhone = vPhone.replace(/[^0-9]/g, '')
        const lPhone = vPhone.length
        vPhone = vPhone.replace(/^(\d\d)(\d)/g, '($1) $2')
        if (lPhone > 10) {
          vPhone = vPhone.replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15)
        } else {
          vPhone = vPhone.replace(/(\d{4})(\d)/, '$1-$2').slice(0, 14)
        }

        return vPhone
      },

      applyCpfMask (cpf) {
        let vCpf = String(cpf).trim()

        vCpf = vCpf.replace(/[^0-9]/g, '')
        vCpf = vCpf.length > 11 ? vCpf.slice(0, 11) : vCpf // correção para CPF maior que 11 (bug ao colar número grande)

        return vCpf.length === 11 ? cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4') : vCpf
      },

      getUserFromStore (type) {
        if (!!this.$store.state.userSession === false || !!this.$store.state.userSession.userProfile === false) return

        // [24/01/25] console.log('::: GET USER FROM STORE:', type)

        this.loading = false

        const { img, nome, email, ddd, tel, cpf, crm, conta } = this.$store.state.userSession.userProfile

        const phone = !!ddd === true && !!tel === true ? `${ddd}${tel}` : ''

        this.image.preview = img
        this.nome = nome
        this.email = email
        this.ddd = ddd
        this.tel = tel
        this.phone = this.applyPhoneMask(phone)
        this.cpf = this.applyCpfMask(cpf)
        this.crm = crm
        this.conta = conta

        // [24/01/25] console.log(`::: PROFILE > user[${type}]:`, this.$store.state.userSession)
      },

      onCpfChange (val) {
        // [24/01/25] console.log('onCpfChange:', this.userSession.userProfile.cpf, this.cpf, val.target.value)

        let v = String(val.target.value)

        // Remove tudo o que não é dígito
        v = v.replace(/[^0-9]/g, '')

        // correção ao colar um número maior que 11 digitos
        /* if (v.length > 11) {
          val.target.value = v.slice(0, 11)
          this.cpf = v.slice(0, 11)
        } */

        if (v.length === 0) {
          val.target.value = ''
          this.cpf = ''
          // this.cpf = this.userSession.userProfile.cpf
          return false
        }

        // [24/01/25] console.log('onCpfChange[1]:', v)

        /* if (v.length !== 11) {
          this.cpf = String(val.target.value).trim()
          // this.cpf = this.applyCpfMask(this.userSession.userProfile.cpf || '')

          return false
        } */

        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
        v = v.slice(0, 14)

        val.target.value = v
        this.cpf = v

        return true
      },

      onPhoneChange (val) {
        // [24/01/25] console.log('onPhoneChange:', this.userSession.userProfile.phone, this.phone, val.target.value)

        let v = String(val.target.value)

        /* if (v.length === 0) {
          this.phone = this.applyPhoneMask(this.userSession.userProfile.phone || '')
          return false
        } */

        var len = 0

        // Remove tudo o que não é dígito
        v = v.replace(/[^0-9]/g, '')

        len = v.length

        if (len === 0 || len > 11) {
          const maskedPhone = this.applyPhoneMask(this.userSession.userProfile.phone || '')

          val.target.value = maskedPhone
          this.phone = maskedPhone

          const thePhone = maskedPhone.split(' ')
          this.ddd = thePhone[0].slice(1, 3).trim()
          this.tel = thePhone[1].split('-').join('').trim()
          return false
        }

        // Coloca parênteses em volta dos dois primeiros dígitos
        v = v.replace(/^(\d\d)(\d)/g, '($1) $2')

        // Coloca hífen entre o quarto e o quinto dígitos
        if (len > 10) {
          v = v.replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15)
        } else {
          v = v.replace(/(\d{4})(\d)/, '$1-$2').slice(0, 14)
        }

        val.target.value = v
        this.phone = v

        if (len === 10 || len === 11) {
          const thePhone = v.split(' ')
          this.ddd = thePhone[0].slice(1, 3).trim()
          this.tel = thePhone[1].split('-').join('').trim()
        }

        return true
      },

      setImage,

      checkPhone (telefone) {
        return /^\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$/.test(telefone)
      },

      checkUsername (username) {
        return username.trim().length >= 3 // /\S+(?:\s+\S+)+/.test(username)
      },

      saveImageFileIntoFirebaseStorage (callback = () => {}) {
        const $this = this
        const { file } = this.image

        if (!file) {
          callback(new Error(false))
          return false
        }

        const contentType = file.type
        const type = contentType.split('/')[1]

        if (type !== 'png' &&
          type !== 'jpg' &&
          type !== 'jpeg') {
          return alert('Por favor selecione uma imagem em formato PNG, JPG, ou JPEG.')
        }

        const name = `${new Date().getTime()}.${contentType.split('/')[1]}`
        const storageRef = firebase.storage().ref(`images/${name}`)
        const uploadTask = storageRef.put(file, { contentType })
        return uploadTask.on(
          'state_changed',
          snapshot => {
            // [24/01/25] const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            // [24/01/25] console.log(`Upload is ${progress}% done`)
          },
          () => alert('Erro', 'Erro ao efetuar upload'),
          () => uploadTask.snapshot.ref.getDownloadURL()
            .then(downloadURL => {
              $this.image.preview = downloadURL
              callback(downloadURL)
            }),
        )
      },

      async saveProfile (type)
      {
        if (!this.hasChanged) {
          // correção ao colar um número maior que 11 digitos
          const fixCpf = this.cpf.replace(/[^0-9]/g, '')
          if (fixCpf.length > 11) this.cpf = this.applyCpfMask(fixCpf.slice(0, 11))

          // [24/01/25] console.log('::: NENHUM CAMPO FOI ALTERADO:', type)
          return
        }

        // [24/01/25] console.log('::: SALVANDO ALTERAÇÕES NO PERFIL, ORIGEM:', type)

        const uid = apiGetUserId()

        if (!!uid === false) return false

        /* TRATA CAMPOS ATUAIS */

        const userImg = this.userSession.userProfile.img && this.userSession.userProfile.img.trim().length > 0 ? this.userSession.userProfile.img.trim() : ''
        const userNome = this.userSession.userProfile.nome && this.userSession.userProfile.nome.trim().length > 0 ? this.userSession.userProfile.nome.trim() : ''
        const userEmail = this.userSession.userProfile.email && this.userSession.userProfile.email.trim().length > 0 ? this.userSession.userProfile.email.trim() : ''
        const userPhone = this.userSession.userProfile.phone && this.userSession.userProfile.phone.trim().length > 0 ? this.userSession.userProfile.phone.trim() : ''
        const userDdd = this.userSession.userProfile.ddd && this.userSession.userProfile.ddd.trim().length > 0 ? this.userSession.userProfile.ddd.trim() : ''
        const userTel = this.userSession.userProfile.tel && this.userSession.userProfile.tel.trim().length > 0 ? this.userSession.userProfile.tel.trim() : ''
        const userCrm = this.userSession.userProfile.crm && this.userSession.userProfile.crm.trim().length > 0 ? this.userSession.userProfile.crm.trim() : ''
        const userConta = this.userSession.userProfile.conta && this.userSession.userProfile.conta.trim().length > 0 ? this.userSession.userProfile.conta.trim() : ''

        let userCpf = this.userSession.userProfile.cpf && this.userSession.userProfile.cpf.trim().length > 0 ? this.userSession.userProfile.cpf.replace(/[^0-9]/g, '') : ''
        userCpf = userCpf.length > 11 ? userCpf.slice(0, 11) : userCpf // correção para CPF maior que 11 (bug ao colar número grande)

        /* TRATA OS CAMPOS */

        const { email, phone } = this

        const img = this.image && this.image.preview && this.image.preview.trim().length > 0 ? this.image.preview.trim() : ''
        const nome = this.nome && this.nome.trim().length > 0 ? this.nome.trim() : ''
        let ddd = this.ddd && this.ddd.trim().length > 0 ? this.ddd.trim() : ''
        let tel = this.tel && this.tel.trim().length > 0 ? this.tel.trim() : ''
        let cpf = this.cpf && this.cpf.trim().length > 0 ? this.cpf.replace(/[^0-9]/g, '') : ''
        cpf = cpf.length > 11 ? cpf.slice(0, 11) : cpf // correção para CPF maior que 11 (bug ao colar número grande)
        const crm = this.crm && this.crm.trim().length > 0 ? this.crm.trim() : ''
        const conta = this.conta && this.conta.trim().length > 0 ? this.conta.trim() : ''

        if (phone && phone.length > 11) {
          const thePhone = phone.split(' ')
          ddd = thePhone[0].slice(1, 3).trim()
          tel = thePhone[1].split('-').join('').trim()
        }

        /* MOSTRA INFORMAÇÕES QUE MUDARAM */
        // [24/01/25] if (img !== userImg) console.log(`user.img[changed]: "${userImg}" > "${img}"`)
        // [24/01/25] if (nome !== userNome) console.log(`user.nome[changed]: "${userNome}" > "${nome}"`)
        // [24/01/25] if (email !== userEmail) console.log(`user.email[changed]: "${userEmail}" > "${email}"`)
        // [24/01/25] if (phone !== userPhone) console.log(`user.phone[changed]: "${userPhone}" > "${phone}"`)
        // [24/01/25] if (ddd !== userDdd) console.log(`user.ddd[changed]: "${userDdd}" > "${ddd}"`)
        // [24/01/25] if (tel !== userTel) console.log(`user.tel[changed]: "${userTel}" > "${tel}"`)
        // [24/01/25] if (cpf !== userCpf) console.log(`user.cpf[changed]: "${userCpf}" > "${cpf}"`)
        // [24/01/25] if (crm !== userCrm) console.log(`user.crm[changed]: "${userCrm}" > "${crm}"`)
        // [24/01/25] if (conta !== userConta) console.log(`user.conta[changed]: "${userConta}" > "${conta}"`)

        /* INFORMAÇÕES QUE VÃO ENTRAR NO BD */

        let updatesCount = 0
        const updates = {}

        if (img !== userImg) {
          updates['/users/' + uid + '/img'] = img
          updatesCount++
        }

        if (this.checkUsername(nome) && nome !== userNome) {
          updates['/users/' + uid + '/nome'] = nome.trim()
          updatesCount++
        } else {
          this.nome = userNome || ''
        }

        if (email !== userEmail) {
          updates['/users/' + uid + '/email'] = email
          updatesCount++
        }

        if (this.checkPhone(phone) && phone !== userPhone) {
          updates['/users/' + uid + '/ddd'] = ddd
          updates['/users/' + uid + '/tel'] = tel
          updatesCount++
        } else {
          /* const maskedPhone = this.applyPhoneMask(userPhone || '')

          // val.target.value = maskedPhone
          this.phone = maskedPhone

          const thePhone = maskedPhone.split(' ')
          this.ddd = thePhone[0].slice(1, 3).trim()
          this.tel = thePhone[1].split('-').join('').trim() */

          this.phone = this.applyPhoneMask(userPhone || '')
          this.ddd = userDdd || ''
          this.tel = userTel || ''
        }

        if ((isValidCPF(cpf) && cpf !== userCpf) || (cpf === '' && cpf !== userCpf)) {
          updates['/users/' + uid + '/cpf'] = cpf
          updatesCount++
        } else {
          this.cpf = userCpf.length > 0 ? this.applyCpfMask(userCpf || '') : ''
        }

        if (crm !== userCrm) {
          updates['/users/' + uid + '/crm'] = crm.trim()
          updatesCount++
        }

        if (conta !== userConta) {
          updates['/users/' + uid + '/conta'] = conta.trim()
          updatesCount++
        }

        // [24/01/25] console.log('::: SALVAR PERFIL:', updatesCount, updates)

        /* COLOCA NO BANCO DE DADOS */

        if (updatesCount > 0)
        {
          this.loading = true
          const response = await fbFullUpdate(updates)
          this.loading = false

          // [24/01/25] console.log('::: PERFIL SALVO:', response)

          if (response.code === 0) {
            alert('Não conseguimos salvar seus dados. Por favor, contate nosso suporte.')
          }
        }
      },

      fileToBase64 (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })
      },

      async handleImageChange (file) {
        const $this = this
        this.loading = true
        /**
         * Caso precise do arquivo de imagem em
         * formato base64, descomente a linha a baixo.
         */
        const base64 = await this.fileToBase64(file)
        $this.image.preview = base64
        $this.image.file = file
        this.saveImageFileIntoFirebaseStorage(imageURL => {
          $this.image.preview = imageURL
          $this.loading = false
          $this.saveProfile('image')
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .field {
    padding: 10px 0;
  }

  .fieldLabel {
    label {
      position: relative;

      color: #777777;
      font-size: 14px;
      font-weight: 400;

      &[data-type="required"] {
        &::before {
          content: '*';

          position: absolute;
          top: -4px;
          right: -10px;

          color: indianred;
          font-size: 12px;
          font-weight: 800;
        }
      }
    }
  }

  .fieldIcon {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0 !important;
    right: 12px;
  }

  .fieldInput {
    transition-property: border-bottom-color;
    transition-duration: 300ms;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    padding: 7px 40px 10px 0;
    /* border-radius: 10px; */
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    outline: 0;
    /* box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.25); */
    color: #444444;
    font-size: 15px;

    &::placeholder {
      color: #999999;
    }

    &:disabled {
      color: #777777;
      /* background-color: rgba(0, 0, 0, 0.04); */
      opacity: 0.4;
    }
  }

  .fieldTextarea {
    transition-property: border-bottom-color;
    transition-duration: 300ms;
    width: 100%;
    min-height: 100px;
    max-height: 200px;
    background-color: #ffffff;
    /* padding: 7px 40px 10px 0; */
    padding: 7px 60px 10px 0;
    /* border-radius: 10px; */
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    outline: 0;
    /* box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.25); */
    color: #444444;
    font-size: 15px;
    line-height: 25px;

    resize: vertical;

    &::placeholder {
      color: #999999;
    }

    &:disabled {
      color: #777777;
      /* background-color: rgba(0, 0, 0, 0.04); */
      opacity: 0.4;
    }
  }

  .fieldBlock {
    position: relative;
    display: block;
    width: 100%;
  }

  .searchResult {
    position: absolute;
    left: 10px;
    bottom: -25px;
    color: indianred;
    font-weight: 500;
    font-size: 14px;
  }

  #blockUserProfile {
    position: relative;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;

    padding-top: 35px;
    // padding-bottom: 70px;
    padding-bottom: 25px;
    margin-bottom: 15px;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

    color: rgba(0, 0, 0, 0.87);
  }

  .saveIcon {
    position: absolute;
    right: 35px;
    top: 25px;
  }

  .blockTitle {
    color: #305050;
    font-size: 30px;
    line-height: 40px;
  }

  #pageHeader {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 30px;
    min-height: 100px;
  }

  #avatar-preview {
    position: relative;
    cursor: pointer;
    opacity: 0.85;
    transition: 0.2s ease-out;
    background-color: #ccc;
    &:hover {
      opacity: 1;
    }
  }

  #avatar-label {
    position: relative;
    margin-bottom: 0;
    border-radius: 50%;
  }

  #avatar-button {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .halfVisible {
    opacity: 0.75;
    transition: ease-out 0.1s;
    cursor: default !important;
    &:hover {
      opacity: 1;
    }
  }
</style>
